import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const StyledButton = styled(Button)`
  &.nav-selected {
    background-color: var(--color_lvl_3);
    color: var(--color_lvl_-5);
  }
`;
